export type ButtonType = React.FC<{ getText?: () => string | null }>;

let buttonComponent: ButtonType | null = null;

export function setCopyButtonComponent(btn: ButtonType) {
    buttonComponent = btn;
}

export function getCopyButtonComponent() {
    return buttonComponent;
}
